'use strict';

angular.module('ClinicApp').factory('PermissionService', function($q, PermissionResource, PermissionMetadataResource) {
  return {
    createPermission: function(modelType, modelId, userEmail) {
      if (!userEmail) {
        return $q.reject('PermissionService.createPermission: userEmail is required.');
      }
      return PermissionResource.save({
        modelType: modelType,
        id: modelId,
      }, {
        email: userEmail,
      }).$promise;
    },

    removePermission: function(modelType, modelId, userId) {
      return PermissionResource.remove({
        modelType: modelType,
        id: modelId,
        userId: userId,
      }).$promise;
    },

    updatePermissionMetadata: function(modelType, modelId, userId, metadata) {
      return PermissionMetadataResource.update({
        modelType: modelType,
        id: modelId,
        userId: userId,
      }, {
        metadata: metadata,
      }).$promise;
    },
  };
});
